import React from "react";
import { Form, Upload, Progress, Image } from "antd";
import { InboxOutlined, DeleteOutlined } from "@ant-design/icons";

const MediaUpload = ({
  fileList,
  previewUrl,
  uploading,
  uploadPercent,
  handleChange,
  handleClear,
  modifyFileName,
}) => {
  return (
    <Form.Item label="Upload Media">
      <Upload.Dragger
        name="file"
        multiple={false}
        customRequest={({ file }) => {}}
        maxCount={1}
        beforeUpload={() => false}
        showUploadList={false}
        accept="image/*"
        onChange={handleChange}
        fileList={fileList}
        className="custom-dragger"
        openFileDialogOnClick={!previewUrl}
        style={{
          minHeight: 195,
          minWidth: 180,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto",
          marginTop: "95px",
        }}
      >
        {previewUrl ? (
          <div style={{ textAlign: "center" }}>
            <Image
              src={previewUrl}
              alt="Uploaded"
              preview={true}
              style={{
                maxHeight: "100px",
                maxWidth: "100%",
                objectFit: "contain",
                cursor: "pointer",
              }}
              onClick={(e) => e.stopPropagation()}
            />
            <div
              style={{
                fontSize: "13px",
                color: "#595959",
                marginTop: "7.5px",
              }}
            >
              {(() => {
                const name = fileList[0]?.name;
                if (!name) return "";

                const modifiedName = modifyFileName(name);
                const dotIndex = modifiedName.lastIndexOf(".");
                const ext = modifiedName.substring(dotIndex);
                const base = modifiedName.substring(0, dotIndex);

                return base.length > 15
                  ? base.substring(0, 15) + "..." + ext
                  : modifiedName;
              })()}
              <DeleteOutlined
                onClick={handleClear}
                style={{ marginLeft: "5px" }}
              />
            </div>
            {uploading && (
              <Progress
                percent={uploadPercent}
                size="small"
                status={uploadPercent === 100 ? "success" : "active"}
                style={{ marginTop: 10 }}
              />
            )}
          </div>
        ) : (
          <>
            <p className="ant-upload-drag-icon">
              <InboxOutlined style={{ fontSize: "25px" }} />
            </p>
            <p style={{ fontSize: "13px", color: "gray", padding: "0 10px" }}>
              Click or drag image to upload
            </p>
          </>
        )}
      </Upload.Dragger>
    </Form.Item>
  );
};

export default MediaUpload;
